export const WEEKDAYS = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"];

const mins = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
const span = (s, e) => {
  const a = mins(s);
  const b = mins(e);
  return [a, b > a ? b : b + 1440];
};
const weekdayOf = (iso) => (new Date(`${iso}T12:00:00`).getDay() + 6) % 7;

export const dayStatus = (av, iso) => {
  if (!av) return null;
  const off = av.unavailable_dates?.find((x) => x.date === iso);
  if (off) return { off: true, text: off.reason ? `Vrij: ${off.reason}` : "Vrij" };
  const day = av.days[weekdayOf(iso)];
  if (!day.available) return { off: true, text: "Niet beschikbaar" };
  if (day.start && day.end) return { off: false, text: `${day.start}–${day.end}` };
  return null;
};

export const availIssue = (av, iso, start, end) => {
  if (!av || !iso || !start || !end) return null;
  const st = dayStatus(av, iso);
  if (st?.off) return st.text === "Niet beschikbaar" ? "is op deze dag niet beschikbaar" : "heeft deze datum vrij gevraagd";
  const day = av.days[weekdayOf(iso)];
  if (day.start && day.end) {
    const [a, b] = span(start, end);
    const [x, y] = span(day.start, day.end);
    if (a < x || b > y) return `is alleen beschikbaar van ${day.start} tot ${day.end}`;
  }
  return null;
};
